import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "react-drawer/lib/react-drawer.css";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import logo2 from "../../assets/images/logo-limpia-text.png";
import logo3 from "../../assets/images/logo-limpia-sm.png";
import { TbMoonFilled, TbSunFilled, TbPhone, TbMenu2, TbX } from "react-icons/tb";
import { toggleLeftmenu, changeSidebarType } from "../../store/actions";
import { toggleTheme } from "../../store/theme/actions";
import "./index.css";
import { getUserRead } from "../../helpers/backend";

const Header = (props) => {
  const { theme } = props;
  const userid = JSON.parse(localStorage.getItem("user"));
  const [extensionInfo, setExtensionInfo] = useState({
    extension: "",
    is_ext: false
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const getUserData = async () => {
    const response = await getUserRead(userid.id);
    const user= response.data
    setExtensionInfo({
      extension: user.extension || "",
      is_ext: user.is_ext || false
    });
  };
  useEffect(() => {
    getUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Obtener información del usuario al cargar

  // Actualiza los atributos del body cada vez que el tema cambie
  useEffect(() => {
    document.body.setAttribute("data-layout-mode", theme);
    document.body.setAttribute("data-topbar", theme);
    document.body.setAttribute("data-sidebar", theme);
  }, [theme]);

  const handleToggleTheme = () => {
    document.body.classList.add("theme-transition");
    props.toggleTheme();
    setTimeout(() => {
      document.body.classList.remove("theme-transition");
    }, 1000);
  };

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    if (document.body.clientWidth >= 993) {
      if (props.leftSideBarType === "default") {
        props.changeSidebarType("small");
        setIsMenuOpen(false);
      } else if (
        props.leftSideBarType === "small" ||
        props.leftSideBarType === "compact"
      ) {
        props.changeSidebarType("default");
        setIsMenuOpen(true);
      }
    } else {
      const isCurrentlyOpen = document.body.classList.contains("sidebar-enable");
      document.body.classList.toggle("sidebar-enable");
      props.changeSidebarType("default");
      setIsMenuOpen(!isCurrentlyOpen);
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div
              className="navbar-brand-box"
              style={{
                transition: "all .35s ease",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRight:
                  theme === "dark" ? "1px solid #3b3b3b" : "1px solidrgb(15, 123, 178)",
                width: "230px",
                borderBottom:
                  theme === "dark" ? "1px solid #242424" : "1px solid #fff"
              }}
            >
              <Link to="/dashboard" className="logo ">
                <span className="logo-sm">
                  <img
                    src={logo3}
                    alt=""
                    height="25"
                    style={{ filter: "drop-shadow(0 0 .4px white)" }}
                  />
                </span>
                <span className="logo-lg">
                  <img
                    src={logo2}
                    alt=""
                    height="25"
                    width="130"
                    style={{ filter: "drop-shadow(0 0 .2px white)" }}
                  />
                </span>
              </Link>
            </div>
            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <button
                type="button"
                onClick={() => {
                  tToggle();
                }}
                style={{
                  border: "none",
                  background: theme === "dark" 
                    ? "linear-gradient(135deg, #2a3042 0%, #242938 100%)"
                    : "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                  color: theme === "dark" ? "#64748b" : "#475569",
                  position: "absolute",
                  left: "0px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "48px",
                  height: "48px",
                  borderRadius: "0 12px 12px 0",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  cursor: "pointer",
                  outline: "none",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                  boxShadow: "none"
                }}
                className="modern-menu-button"
                id="vertical-menu-btn"
                onMouseEnter={(e) => {
                  e.target.style.background = theme === "dark" 
                    ? "linear-gradient(135deg, #334155 0%, #1e293b 100%)"
                    : "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)";
                  e.target.style.transform = "translateY(-50%) translateX(4px)";
                  e.target.style.color = theme === "dark" ? "#94a3b8" : "#334155";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = theme === "dark" 
                    ? "linear-gradient(135deg, #2a3042 0%, #242938 100%)"
                    : "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)";
                  e.target.style.transform = "translateY(-50%) translateX(0px)";
                  e.target.style.color = theme === "dark" ? "#64748b" : "#475569";
                }}
                onMouseDown={(e) => {
                  e.target.style.transform = "translateY(-50%) translateX(2px) scale(0.95)";
                }}
                onMouseUp={(e) => {
                  e.target.style.transform = "translateY(-50%) translateX(4px) scale(1)";
                }}
              >
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s ease",
                  transform: isMenuOpen || props.leftSideBarType === "default" ? "rotate(180deg)" : "rotate(0deg)"
                }}>
                  {isMenuOpen || props.leftSideBarType === "default" ? (
                    <TbX size={20} style={{ 
                      transition: "all 0.3s ease",
                      filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.1))"
                    }} />
                  ) : (
                    <TbMenu2 size={20} style={{ 
                      transition: "all 0.3s ease",
                      filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.1))"
                    }} />
                  )}
                </div>
              </button>
            </div>
          </div>
          <div className="d-flex align-items-center gap-0">
            {/* Mostrar información de la extensión si existe */}
            {extensionInfo.extension && (
              <div
                className="extension-badge"
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "10px",
                  padding: "5px 10px",
                  borderRadius: "4px",
                  backgroundColor: theme === "dark" ? "#2a3042" : "#f3f6f9",
                  color: theme === "dark" ? "#e0e0e0" : "#495057",
                  fontSize: "14px",
                  border: `1px solid ${
                    theme === "dark" ? "#3b3b3b" : "#e9ebec"
                  }`
                }}
              >
                <TbPhone style={{ marginRight: "5px" }} />
                <span style={{ marginRight: "5px" }}>
                <b>{extensionInfo.extension}</b>  
                </span>
                <span
                  style={{
                    color: extensionInfo.is_ext ? "#34c38f" : "#f46a6a",
                    fontWeight: "500"
                  }}
                >
                  {extensionInfo.is_ext ? "Activa" : "Inactiva"}
                </span>
              </div>
            )}
            <button
              onClick={handleToggleTheme}
              className="btn header-item noti-icon"
              style={{
                background: "transparent",
                display: "grid",
                placeItems: "center",
                border: "none",
                cursor: "pointer",
                fontSize: "19px",
                color: theme === "light" ? "#555b6d" : "#f8f9fa"
              }}
            >
              {theme === "light" ? (
                <TbMoonFilled />
              ) : (
                <TbSunFilled size={21} color="#ffd61f" />
              )}
            </button>

            <NotificationDropdown />
            <ProfileMenu />

            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={toggleFullscreen}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="mdi mdi-fullscreen" />
              </button>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
  theme: PropTypes.string.isRequired,
  toggleTheme: PropTypes.func.isRequired
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
    theme: state.theme.theme
  };
};

export default connect(mapStatetoProps, {
  toggleLeftmenu,
  changeSidebarType,
  toggleTheme
})(Header);
